// extracted by mini-css-extract-plugin
module.exports = {"downContainer":"ServerDown_downContainer__2DINj"};